import React, { Fragment, useEffect, useRef, useState } from 'react'
import { KTSVG } from '../../../_metronic/helpers'
import { useAppDispatch, useAppSelector } from '../../../app/hooks';
import { expensePolicyDetailInitialsForAdd, expensePolicyDetailInitialsForUpdate } from './interfaces/expensePolicyDetailClass';
import { UpdateAccountExpensePolicyCategorybyCategoryAsync, UpdateAccountExpensePolicyGeneralLimitAsync, GetDataByAccountExpensePolicyIdAsync, resetSelectedRecordObjectInState } from './expensePolicyDetailSlice';
import * as yup from 'yup';
import { Formik } from 'formik';
import { ShowToast } from '../../../common/Toastr';
import { Link, useLocation } from 'react-router-dom';
import { determineCommaSeprater, FormatInvoiceDecimalNumber, formatNumberCustomoriginalapiv2, getValueFromResource, parseLocalizedNumber } from '../../../common/timeLiveFunction';

const ExpensePolicyGeneralForm = (props: any) => {
    const { modelRef, t, oncloseModal, CategorymodelRef } = props;
    const defaultFocusRef = useRef<HTMLInputElement>(null);
    const [currentFieldsData, setCurrentFieldsData] = useState<any>(expensePolicyDetailInitialsForAdd);
    const { selectedRecord, isLoading } = useAppSelector((state) => state.expensePolicyDetail);
    
        const { pageId, menuList, IsList, IsAdd, IsEdit, IsDelete, cultureInfoName,decimalPlaces } = useAppSelector((state) => state.globalState);
    const location = useLocation();
    const { MasterExpensePolicyId } = useAppSelector((state) => state.expensePolicy);
    const { obj } = location.state || {};   
    let AccountExpensePolicyId = '00000000-0000-0000-0000-000000000000';
     if (MasterExpensePolicyId && MasterExpensePolicyId !== '') {
        AccountExpensePolicyId = MasterExpensePolicyId;
     } else if (obj && obj.AccountExpensePolicyId) {
        AccountExpensePolicyId = obj.AccountExpensePolicyId;
     }
    const dispatch = useAppDispatch();
    useEffect(() => {
        let stateItem: any = {}
        if (Object.keys(selectedRecord).length > 0) {
            const tempObj: any = selectedRecord;
            Object.keys(expensePolicyDetailInitialsForUpdate).map((item) => {
                return stateItem[item] = tempObj[item];
            })
            stateItem.PolicyDescriptionRequired = stateItem.PolicyDescriptionRequired === true ? true : false;
            stateItem.IsDescriptionRequired = stateItem.IsDescriptionRequired === true ? true : false;
            stateItem.IsOverride = stateItem.IsOverride === true ? true : false;
            stateItem.PolicyAmountLimit = formatNumberCustomoriginalapiv2(cultureInfoName.toString(),stateItem.PolicyAmountLimit, decimalPlaces);
            
            stateItem.PolicyRequiredLimit = formatNumberCustomoriginalapiv2(cultureInfoName.toString(), stateItem.PolicyRequiredLimit, decimalPlaces);

            setCurrentFieldsData(stateItem);

        }
        if (defaultFocusRef.current) {
            defaultFocusRef.current.focus();
        }

    }, [selectedRecord])
    const handleTextChange = (e: any) => {
        setCurrentFieldsData({ ...currentFieldsData, [e.target.id]: (e.target.type === 'checkbox' ? e.target.checked : e.target.value) })
    }
    const handleSubmit = (values: any) => {
         const formattedValues = {
                                        ...values,
                                        PolicyAmountLimit: parseLocalizedNumber(values.PolicyAmountLimit),
                                        PolicyRequiredLimit: parseLocalizedNumber(values.PolicyRequiredLimit)
                                    }

        if (Object.keys(selectedRecord).length > 0) {
            dispatch(UpdateAccountExpensePolicyGeneralLimitAsync(formattedValues))
                .unwrap()
                .then((originalPromiseResult) => {
                    ShowToast("General Limits Update Successfully", 'Success', "success", "toast-top-right");
                })
                .catch((rejectedValueOrSerializedError) => {
                    console.log('handleSubmitGeneral-UpdateAccountExpensePolicyGeneralLimitAsync-rejectedValueOrSerializedError', rejectedValueOrSerializedError);
                })
        }
        oncloseModal();
    }
    const handleCloseOnClickEvent = () => {
        dispatch(GetDataByAccountExpensePolicyIdAsync(AccountExpensePolicyId));
    }


    return (
        <>
            <Formik
                initialValues={currentFieldsData}
                enableReinitialize={true}
                onSubmit={(values, action) => { handleSubmit(values); action.resetForm() }}
                validationSchema={yup.object().shape({
                    PolicyAmountLimit: yup
                        .string()
                        .label(getValueFromResource('PolicyAmountLimit', dispatch, t))
                        .trim()
                        .required(getValueFromResource('Policy Amount Limit is required', dispatch, t))
                        .test(
                            'culture-format-check',
                            () => {
                                const isComma = determineCommaSeprater(cultureInfoName.toString());
                                return isComma
                                    ? "Only numbers and comma (,) are allowed."
                                    : "Only numbers and dot (.) allowed";
                            },
                            (value) => {
                                if (!value) return true; // empty is allowed, required check will handle mandatory
                                const isComma = determineCommaSeprater(cultureInfoName.toString());
                                if (isComma) {
                                    // Allow numbers like 123,45
                                    return /^\d+(,\d+)?$/.test(value);
                                } else {
                                    // Allow numbers like 123.45
                                    return /^\d+(\.\d+)?$/.test(value);
                                }
                            }
                        ),
                    PolicyRequiredLimit: yup
                        .string()
                        .label(getValueFromResource('PolicyRequiredLimit', dispatch, t))
                        .trim()
                        .required(getValueFromResource('Policy Amount Limit is required', dispatch, t))
                        .test(
                            'culture-format-check',
                            () => {
                                const isComma = determineCommaSeprater(cultureInfoName.toString());
                                return isComma
                                    ? "Only numbers and comma (,) are allowed."
                                    : "Only numbers and dot (.) allowed";
                            },
                            (value) => {
                                if (!value) return true; // empty is allowed, required check will handle mandatory
                                const isComma = determineCommaSeprater(cultureInfoName.toString());
                                if (isComma) {
                                    // Allow numbers like 123,45
                                    return /^\d+(,\d+)?$/.test(value);
                                } else {
                                    // Allow numbers like 123.45
                                    return /^\d+(\.\d+)?$/.test(value);
                                }
                            }
                        )
                })}>
                {({ values, handleChange, errors, setFieldTouched, touched, isValid, handleSubmit }) => (
                    <Fragment>
                        <form>
                            <div className='card-body'>
                                {isLoading ?
                                    <div className="col-md-12">
                                        <span className='indicator-progress' style={{ display: 'block' }}>
                                            <span className='spinner-border spinner-border-md ms-2'></span>
                                        </span>
                                    </div>
                                    : <>
                                        <div className="modal drawer-overlay" style={{ display: 'block' }}
                                        >
                                            <div className="modal-dialog">
                                                <div className="modal-content">
                                                    <div className="modal-header" style={{ padding: '.6rem .6rem' }}>
                                                        <h5 className="modal-title mainHeading">
                                                            {/* {t('General Limits')} */}
                                                            {getValueFromResource('General Limits',dispatch, t)}
                                                             </h5>
                                                        <div
                                                            className="btn btn-icon btn-sm btn-active-secondary ms-2 "
                                                            onClick={oncloseModal}
                                                        >
                                                            <KTSVG
                                                                path="/media/icons/duotune/arrows/arr061.svg"
                                                                className="svg-icon svg-icon-1x"
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="modal-body">
                                                        <form className='form'>
                                                            <div className="mb-0">
                                                                <label className="fs-7 fs-7 fw-normal mb-2">
                                                                    {/* {t('Policy Amount Limit')} */}
                                                                    {getValueFromResource('Policy Amount Limit',dispatch, t)}
                                                                    </label>
                                                                <input type="text" className="form-control fs-7 fw-normal mb-2" id='PolicyAmountLimit' value={values.PolicyAmountLimit} name='PolicyAmountLimit'
                                                                    onChange={handleChange('PolicyAmountLimit')}
                                                                    style={{ color: '#172b4d' }}
                                                                    ref={defaultFocusRef}
                                                                    onKeyDown={(e) => {
                                                                        if (e.key === 'Enter') {
                                                                            e.preventDefault();
                                                                            setFieldTouched('PolicyAmountLimit', true);
                                                                            handleSubmit();
                                                                        }
                                                                    }}
                                                                />
                                                            </div>
                                                            <div style={{ paddingRight: 5}}>
                                                                {touched.PolicyAmountLimit && errors.PolicyAmountLimit &&
                                                                    <p className='errorMsg'>{errors.PolicyAmountLimit as string}</p>
                                                                }
                                                            </div>

                                                            <div className="mb-0 mt-2">
                                                                <label className="fs-7 fs-7 fw-normal mb-2 mt-2">
                                                                    {/* {t('Policy Required Limit')} */}
                                                                    {getValueFromResource('Policy Required Limit',dispatch, t)}
                                                                    </label>
                                                                <input type="text" className="form-control fs-7 fw-normal mb-2" id='PolicyRequiredLimit' value={values.PolicyRequiredLimit} name='PolicyAmountLimit'
                                                                    onChange={handleChange('PolicyRequiredLimit')}
                                                                    style={{ color: '#172b4d' }}
                                                                    onKeyDown={(e) => {
                                                                        if (e.key === 'Enter') {
                                                                            e.preventDefault();
                                                                            setFieldTouched('PolicyRequiredLimit', true);
                                                                            handleSubmit();
                                                                        }
                                                                    }}
                                                                />
                                                            </div>
                                                            <div style={{ paddingRight: 5}}>
                                                                {touched.PolicyRequiredLimit && errors.PolicyRequiredLimit &&
                                                                    <p className='errorMsg'>{errors.PolicyRequiredLimit as string}</p>
                                                                }
                                                            </div>

                                                            <div className="mb-3">
                                                                <label className="fs-7 fs-7 fw-normal mt-2">
                                                                    {/* {t('Is Description Required')} */}
                                                                    {getValueFromResource('Is Description Required',dispatch, t)}
                                                                    </label>
                                                                <div className="form-check form-switch form-check-custom form-check-solid">
                                                                <input className="form-check-input h-20px w-30px mt-2" type="checkbox" checked={values.PolicyDescriptionRequired} id="PolicyDescriptionRequired"  onChange={handleChange('PolicyDescriptionRequired')} />
                                                            </div>
                                                            </div>

                                                        </form>
                                                    </div>
                                                    <div className="modal-footer" style={{ padding: '.6rem .6rem' }} >
                                                        <button
                                                            type="button"
                                                            className="btn btn-secondary btn-bs-btn-font-weight btn-sm"
                                                            onClick={oncloseModal}
                                                        >
                                                            {/* {t('Cancel')} */}
                                                            {getValueFromResource('Cancel',dispatch, t)}
                                                        </button>
                                                        <button type="button" className="btn btn-primary  btn-bs-btn-font-weight btn-sm" onClick={() => handleSubmit()} disabled={!isValid}>
                                                        {/* {t('Save')}   */}
                                                        {getValueFromResource('Save',dispatch, t)}
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </>
                                }
                            </div>
                        </form>
                    </Fragment>
                )}
            </Formik>
        </>
     
    )
}

export default ExpensePolicyGeneralForm